import {
  SET_SESSION,
} from '../controllers/session';

/* Hook for maintaining the global session in sync with the
 * returns side session refresh loop, to keep their auth alive
 * outside our redux loops
*/
export default () => next => async action => {
  next(action);

  switch (action.type) {
    case SET_SESSION:
      window.auiSession = { ...action.payload };
      break;

    default:
      break;
  }
};
